import {
    GET_LOCATION_DETAILS_BY_LATLON,
    GET_LOCATION_DETAILS_BY_SLUG,
    GET_LOCATION_DETAILS_BY_POSTALCODE,
    GET_LOCATION_DETAILS_BY_CITYID
} from '../actions/locationDetailsActions';

const initialState = {
    locationDetailsIsRefreshing: false
};

export function locationDetails(state = initialState, action) {
    switch (action.type) {
        case GET_LOCATION_DETAILS_BY_LATLON.pending:
        {
            return {
                ...state,
                locationDetailsIsRefreshing: true
            };
        }

        case GET_LOCATION_DETAILS_BY_LATLON.fulfilled:
        {
            return {
                ...state,
                locationDetails: action.payload,
                lastError: {},
                locationDetailsIsRefreshing: false
            };
        }

        case GET_LOCATION_DETAILS_BY_LATLON.rejected:
        {
            return {
                ...state,
                locationDetails: undefined,
                lastError: action.payload,
                locationDetailsIsRefreshing: false
            };
        }

        case GET_LOCATION_DETAILS_BY_SLUG.pending:
        {
            return {
                ...state,
                locationDetailsIsRefreshing: true
            };
        }

        case GET_LOCATION_DETAILS_BY_SLUG.fulfilled:
        {
            return {
                ...state,
                locationDetails: action.payload,
                lastError: {},
                locationDetailsIsRefreshing: false
            };
        }

        case GET_LOCATION_DETAILS_BY_SLUG.rejected:
        {
            return {
                ...state,
                locationDetails: undefined,
                lastError: action.payload,
                locationDetailsIsRefreshing: false
            };
        }

        case GET_LOCATION_DETAILS_BY_POSTALCODE.pending:
        {
            return {
                ...state,
                locationDetailsIsRefreshing: true
            };
        }

        case GET_LOCATION_DETAILS_BY_POSTALCODE.fulfilled:
        {
            return {
                ...state,
                locationDetails: action.payload,
                lastError: {},
                locationDetailsIsRefreshing: false
            };
        }

        case GET_LOCATION_DETAILS_BY_POSTALCODE.rejected:
        {
            return {
                ...state,
                locationDetails: undefined,
                lastError: action.payload,
                locationDetailsIsRefreshing: false
            };
        }

        case GET_LOCATION_DETAILS_BY_CITYID.pending:
        {
            return {
                ...state,
                locationDetailsIsRefreshing: true
            };
        }

        case GET_LOCATION_DETAILS_BY_CITYID.fulfilled:
        {
            return {
                ...state,
                locationDetails: action.payload,
                lastError: {},
                locationDetailsIsRefreshing: false
            };
        }

        case GET_LOCATION_DETAILS_BY_CITYID.rejected:
        {
            return {
                ...state,
                locationDetails: undefined,
                lastError: action.payload,
                locationDetailsIsRefreshing: false
            };
        }
    }

    return state;
}
